module.exports = __webpack_public_path__ + "img/image4.a8b1b00a.png";